import { CoproductionsScreen } from '@features/coproductions'

export function CoproducoesPage({ inviteToken }: { inviteToken?: string }) {
  return <CoproductionsScreen inviteToken={inviteToken} />
}
